import React from 'react';
import { FooterTypes } from './footerTypes';
import { Container, Footer } from '@codeparva/ui-components-library';
import { LocationProvider } from '@reach/router';
import { VariantContext } from './hooks/VariantContext';
import {
  FooterVariantOne,
  FooterVariantTwo,
  FooterVariantThree,
  FooterESIMVariant,
} from './variants/FooterVariantHelper';
import { ThemeContext } from './hooks/themeContext';
import { NewFooterVariantOne } from './variants/NewFooterVariant';

export const FooterComponent = ({
  theme = 'dark',
  variant = 'footer-1',
  locationType,
  labelsAndLogos,
  show,
  curlocations,
  isHoursForAllLocationsSame,
  locations,
  iconsConfig,
  buttonsConfig,
  navLinks,
  termsPrivacySiteMapAndDisclaimer,
}: FooterTypes.IFooterConfig) => {
  const { contactDetails, socialIcons } = locations.location;
  const labelsLogoandCityStateNames: FooterTypes.TLabelsLogoandCityStateNames = {
    labelsAndLogos,
    locationType,
    buttonsConfig,
  };
  const contactDetailsFooter: FooterTypes.TContactDetailsFooter = {
    contactDetails,
    iconsConfig,
  };
  const socialMediaIconsData: FooterTypes.TSocialIcons = {
    socialIcons,
  };
  const quickLinksandReachUsData: FooterTypes.TNavLinks = {
    navLinks,
    contactDetails,
    labelsAndLogos,
    contactDetailsFooter,
  };
  const facilityGateHours = {
    show,
    curlocations,
    isHoursForAllLocationsSame,
    locationType,
  };
  const variantData: FooterTypes.TFooterVariantData = {
    quickLinksandReachUsData,
    socialMediaIconsData,
    labelsAndLogos,
    contactDetails,
    termsPrivacySiteMapAndDisclaimer,
    labelsLogoandCityStateNames,
    facilityGateHours,
  };

  const esimVariantData = {
    labelsAndLogos,
    contactDetails,
  };

  const renderSwitch = (variant: FooterTypes.TFooterVariantModes) => {
    switch (variant) {
      case 'new-footer-1':
        return <NewFooterVariantOne {...variantData} />;
      case 'footer-2':
        return <FooterVariantTwo {...variantData} />;
      case 'footer-3':
        return <FooterVariantThree {...variantData} />;
      case 'esim-type':
        return <FooterESIMVariant {...esimVariantData} />;
      default:
        return <FooterVariantOne {...variantData} />;
    }
  };
  const selectClassName = (
    variant: FooterTypes.TFooterVariantModes,
    theme: FooterTypes.TThemeModes
  ) => {
    if (theme === 'light') {
      return variant === 'footer-2'
        ? 'footerElementVariantTwoLightTheme'
        : 'footerElementLightTheme';
    } else {
      return variant === 'footer-2'
        ? 'footerElementVariantTwoDarkTheme'
        : 'footerElementDarkTheme';
    }
  };

  return (
    <VariantContext.Provider value={variant}>
      <ThemeContext.Provider value={theme}>
        <LocationProvider>
          <Footer className={selectClassName(variant, theme)}>
            <Container className="my-0">
              {variant && renderSwitch(variant)}
            </Container>
          </Footer>
        </LocationProvider>
      </ThemeContext.Provider>
    </VariantContext.Provider>
  );
};
